import axios, {HttpStatusCode} from 'axios';
import {BASE_ENDPOINT, DEBUG} from "../settings";
import ENDPOINTS from "../constants/endpoints";
import {ROUTES} from "../constants/PathRoutes";

const LOGIN_EXPIRED = 'Login Expirado'
axios.defaults.baseURL = BASE_ENDPOINT

axios.interceptors.request.use((config) => {
    config['withCredentials'] = true

    const pattern = /^v\d+/;
    if (!pattern.test(config.url)) {
        let version = config['version'] || 'v1'
        if (!config['baseURL']?.includes(version)) {
            config['baseURL'] = config['baseURL']?.replace(/\/$/, '') + '/' + version + '/'
        }
    }
    return config;
}, (error) => {
    return Promise.reject(error);
})

axios.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        DEBUG && console.log(error)
        const originalRequest = error.config;

        if (error.response?.status === HttpStatusCode.Unauthorized) {
            if (error.response?.data?.['code'] === 'token_not_valid' && !originalRequest._retry) {
                originalRequest._retry = true;
                try {
                    // Chama o endpoint de renovação de token
                    await axios.post(ENDPOINTS.AUTH_LOGIN_REFRESH)


                    return axios(originalRequest);
                } catch (err) {

                    window.location.href = ROUTES.ADMIN_LOGIN;
                    // Redireciona para login se a renovação falhar
                    return _logout_and_redirect()

                }

            }
            if (error.response?.data?.['code'] === 'not_authenticated') {
                window.location.href = ROUTES.ADMIN_LOGIN;
            }
        }
        return Promise.reject(error);
    }
);

function _logout_and_redirect() {
    return Promise.reject({
        'message': LOGIN_EXPIRED,
        'error': LOGIN_EXPIRED,
        'detail': LOGIN_EXPIRED,
        "response": {
            'message': LOGIN_EXPIRED,
            'error': LOGIN_EXPIRED,
            'detail': LOGIN_EXPIRED,
            'data': {
                'message': LOGIN_EXPIRED,
                'error': LOGIN_EXPIRED,
                'detail': LOGIN_EXPIRED,
            }
        }
    })
}

export default axios;